import React from 'react';

const medium = (
	<svg height="56.6934px" id="Layer_1" style={{enableBackground:"new 0 0 56.6934 56.6934"}} version="1.1" viewBox="0 0 56.6934 56.6934" width="56.6934px" xmlns="http://www.w3.org/2000/svg">
		<g>
			<path d="M38.0334,42.1459l14.9494,7.4733c0.0265,0.0132,0.0505,0.0233,0.0713,0.0315c0.0025-0.0216,0.0042-0.0481,0.0042-0.0779   V17.7293L38.0334,42.1459z"/>
			<polygon points="37.0932,6.9992 26.4859,24.1613 36.687,40.7398 52.661,14.7827  "/>
			<polygon points="20.3149,33.2962 34.1558,40.2157 20.3149,17.726  "/>
			<path d="M3.0002,41.4627c0,0.2339,0.2297,0.6053,0.4386,0.7097l14.917,7.4585c0.0274,0.0132,0.0514,0.0249,0.0721,0.0315   c0.0026-0.0216,0.0042-0.0481,0.0042-0.078V14.9816L3.001,7.2661L3.0002,41.4627z"/>
		</g>
	</svg>)

export default medium;





// WEBPACK FOOTER //
// ./src/components/Websites/About/SVGs/medium.js